import {Point, divIcon} from 'leaflet';
import {useCallback} from 'react';
import {Marker as LeafetMarker, Popup, useMap} from 'react-leaflet';

import {MAP_DEFAULTS} from '../../utils/constants';

import {MapCardContainer} from './common';

import type {GeoFeatureProperties} from '../../functions/createGeoFeatures';
import type {LeafletMouseEvent, Map} from 'leaflet';
import type {PointFeature} from 'supercluster';

const padding = new Point(0, 150);

type MarkerPinProps<P> = {
  marker: PointFeature<P>;
  maxZoom: number;
  shouldPadPopup: boolean;
  children?: (m: PointFeature<P>, map: Map) => React.ReactNode;
};
export function MarkerPin<P extends GeoFeatureProperties>(
  props: MarkerPinProps<P>
): React.JSX.Element {
  const {marker} = props;
  const map = useMap();

  const handleZoomClick = useCallback(
    (e: LeafletMouseEvent): void => {
      map.flyTo(e.latlng, props.maxZoom, {
        duration: MAP_DEFAULTS.animDuration,
      });
    },
    [map, props.maxZoom]
  );

  return (
    <LeafetMarker
      icon={divIcon({html: props.marker.properties.markup})}
      position={{
        lat: marker.geometry.coordinates[1],
        lng: marker.geometry.coordinates[0],
      }}
      eventHandlers={{
        contextmenu: handleZoomClick,
      }}
    >
      {props.children && (
        <Popup
          autoPan={true}
          closeButton={false}
          keepInView={true}
          closeOnClick={true}
          autoPanPaddingTopLeft={props.shouldPadPopup ? padding : undefined}
        >
          <MapCardContainer onClick={() => map.closePopup()}>
            {props.children(marker, map)}
          </MapCardContainer>
        </Popup>
      )}
    </LeafetMarker>
  );
}
